import { BaseService } from "services/_baseService";
import appAxios from "services/axios";
import { AxiosRequestConfig } from "axios";

class MembersAdminService extends BaseService<any> {
  constructor() {
    super(`members`);
  }

  // Станция, привязанная к сотруднику (оператору приёмки/выдачи). data — станция или null.
  getStation = (memberID: any, config?: AxiosRequestConfig) =>
    appAxios.get(`${this.pathWithOrg()}/${memberID}/stations`, config);

  // Установка/снятие станции сотрудника. payload: { stationID: string | null }
  setStation = (memberID: any, stationID: string | null) =>
    appAxios.put(`${this.pathWithOrg()}/${memberID}/stations`, { stationID });
}

export default new MembersAdminService();
